var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form',{attrs:{"inline":""}},[_c('b-form-select',{staticClass:"mr-2",attrs:{"options":_vm.prioritats_select,"size":"sm"},model:{value:(_vm.prioritat),callback:function ($$v) {_vm.prioritat=$$v},expression:"prioritat"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }